module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/sprite-2x-b2647f481f13ca2083933c464508a9d7.png";